import { render } from "./ControlTable.vue?vue&type=template&id=2b1320ab"
import script from "./ControlTable.vue?vue&type=script&lang=js"
export * from "./ControlTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__